import { render } from "./DatabaseSelector.vue?vue&type=template&id=3feaf86e"
import script from "./DatabaseSelector.vue?vue&type=script&lang=js"
export * from "./DatabaseSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__